declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SaveProviderServiceChargeRequest, SaveSingleEmbryoGradeInfoRequest, ActorImageController, IvfEmbryoGradingByCycleController, IvfEmbryoGradingByCycleRequest, SaveEmbryoStoreInfoRequest, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, IvfCycleEmbryoTransferrablesController, IvfCycleEmbryoTransferrablesRequest, IvfCycleEmbryoStorageAreaController, IvfCycleEmbryoStorageAreaRequest, SaveIvfCycleEmbryoTransferredInfoRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgbActorDocsModal } from '../../profile/modals/actordocs/actordocs.modal';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'ngbeditgradinget',
  templateUrl: './editgradinget.modal.html',
  styleUrls: ['./editgradinget.modal.scss']
})

export class NgbEditGradingetModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;
  @Input() EmbryoGradeCode: number;
  @Input() model: string;
  @Input() Select: boolean = false;
  @Input() DocumentUrl: string;
  @Input() CurrentSaveSingleEmbryoGradeInfoRequest: SaveSingleEmbryoGradeInfoRequest;
  @Input() ServiceCode: number;
  @Input() Wellno: number;
  @Input() ImageCodenew: number;
  @Input() Technique: string;
  @Input() oqa: string;
  @Input() Day: number;
  @Input() EggSourceType: string;
  @Input() EggActorCode: number;
  //@Input() Cyclenumberdonor: number;
  public Date: Date;
  public EmbryoGradingCode: number;
  public DOC: number;
  public Embryocount: number;
  public Cycleno: number;
  public Cyclenumberdonor: number;
  public StrawSelected: string;
  public TabsView: boolean = true;
  public EmbryoSelected: boolean = false;
  public SelectedEmbryoDetails: boolean = false;
  public DOC1: number;
  public StrawNumber: string;
  public Count: number;
  public Grade1: string;
  public Grade2: string;
  public Date3: Date;
  @Input() PatientName: string;
  @Input() Cyclenumber: number;
  @Input() ActorCode: number;
  public
  searchTitle: string;
  public ApiResData: ApiResponseModel;
  public EmbryostoreCode: number;
  public EmbryoTransferCode: number;
  ValueChangeActorImageController: ActorImageController;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  public discard: boolean = true;
  public freeze: boolean = false;
  public Transfer: boolean = false;
  public Grade1new: string;
  public Grade2new: string;
  public Cyclenumber1: string;
  public length: number;
  public length2: number;
  public SelectedEmbryoStoreDetails: boolean = false;;
  public SaveTransfer: boolean = false;
  public Canisterno: string;
  public Goblet: string;
  public Hexa: string;
  public Viso: string;
  public UsedCount: number;
  //public IsSelected: boolean;
  CurrentSaveProviderServiceChargeRequest: SaveProviderServiceChargeRequest;
  CurrentDeleteProviderServiceChargeRequest: SaveProviderServiceChargeRequest;
  CurrentSaveEmbryoStoreInfoRequest: SaveEmbryoStoreInfoRequest;
  CurrentSaveIvfCycleEmbryoTransferredInfoRequest: SaveIvfCycleEmbryoTransferredInfoRequest;
  CurrentIvfEmbryoGradingByCycleController: IvfEmbryoGradingByCycleController[];
  CurrentIvfEmbryoGradingByCycleRequest: IvfEmbryoGradingByCycleRequest;

  LoadGradingData() {
    //alert("ScansData")
    this.CurrentIvfEmbryoGradingByCycleRequest = new IvfEmbryoGradingByCycleRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfEmbryoGradingByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfEmbryoGradingByCycleController();
  }
  //AddRowMaturity() {
  //  if (this.CurrentOocyteMaturityByCycleController == null) {
  //    this.CurrentOocyteMaturityByCycleController = new Array<OocyteMaturityByCycleController>();
  //  }
  //  if (this.CurrentOocyteMaturityByCycleController != null) {

  //    var row = new OocyteMaturityByCycleController();

  //    row.MaturityLevel = "";
  //    row.OccCount = 0;
  //    row.DenudedCount = 0;
  //    this.CurrentOocyteMaturityByCycleController.push(row);
  //    this.tosterservice.ToasterSuccessAlertParam('New Row Added Successfully.....!');

  //  }

  //}
  //checkDoc(val: number): boolean {
  //    return val.toString() == this.DOC;
  //}
  GetIvfEmbryoGradingByCycleController() {
    //  alert(this.DOC);
    this.CurrentIvfEmbryoGradingByCycleRequest.ConditionalOperator = 10;
    this.CurrentIvfEmbryoGradingByCycleRequest.CycleCode = this.Cyclenumber;
    this.CurrentIvfEmbryoGradingByCycleRequest.DOC = "";


    this.actorservice.GetIvfEmbryoGradingByCycleController(this.CurrentIvfEmbryoGradingByCycleRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentIvfEmbryoGradingByCycleController = this.ApiResData.Result;
          //   var _CurrentIvfEmbryoGradingByCycleController: IvfEmbryoGradingByCycleController[]  = this.ApiResData.Result;
          //   alert('grades count: ' + _CurrentIvfEmbryoGradingByCycleController.length.toString());
          //this.CurrentIvfEmbryoGradingByCycleController = _CurrentIvfEmbryoGradingByCycleController.filter(
          //    function (v, i, d) {
          //    //if (v.DOC.toString() == this.DOC)
          //    //    alert('Mmmmmm');
          //        return this.checkDoc(v.DOC);//.toString() == this.DOC
          //});
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
  SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;

  CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
  LoadPatients() {
    this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = this.ActorCode;
    this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.Cyclenumber;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCyclesByActorCodeController();
  }

  GetTreatmentCyclesByActorCodeController() {
    this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
          this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
          //this.LMPDate = this.SelectedTreatmentCycle.LMP;

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadPlans();
          //this.LoadPlan();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentIvfCycleEmbryoTransferrablesController: IvfCycleEmbryoTransferrablesController[];
  //CurrentIvfCycleEmbryoTransferrablesController1: IvfCycleEmbryoTransferrablesController[];
  //CurrentIvfCycleEmbryoTransferrablesController2: IvfCycleEmbryoTransferrablesController[];
  //CurrentIvfCycleEmbryoTransferrablesController3: IvfCycleEmbryoTransferrablesController[];
  CurrentIvfCycleEmbryoTransferrablesRequest: IvfCycleEmbryoTransferrablesRequest;

  LoadGradingData2(StrawNumber2: string) {
    //alert("ScansData")
    this.CurrentIvfCycleEmbryoTransferrablesRequest = new IvfCycleEmbryoTransferrablesRequest();
    this.CurrentIvfCycleEmbryoTransferrablesRequest.StrawNumber = StrawNumber2;
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleEmbryoTransferrablesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleEmbryoTransferrablesController();
  }
  //AddRowMaturity() {
  //  if (this.CurrentOocyteMaturityByCycleController == null) {
  //    this.CurrentOocyteMaturityByCycleController = new Array<OocyteMaturityByCycleController>();
  //  }
  //  if (this.CurrentOocyteMaturityByCycleController != null) {

  //    var row = new OocyteMaturityByCycleController();

  //    row.MaturityLevel = "";
  //    row.OccCount = 0;
  //    row.DenudedCount = 0;
  //    this.CurrentOocyteMaturityByCycleController.push(row);
  //    this.tosterservice.ToasterSuccessAlertParam('New Row Added Successfully.....!');

  //  }

  //}
  //checkDoc(val: number): boolean {
  //    return val.toString() == this.DOC;
  //}
  GetIvfCycleEmbryoTransferrablesController() {
    this.spinner.show();
    //  alert(this.DOC);
    this.CurrentIvfCycleEmbryoTransferrablesRequest.ConditionalOperator = 10;
    this.CurrentIvfCycleEmbryoTransferrablesRequest.CycleCode = this.Cyclenumber;

    // this.CurrentIvfEmbryoGradingByCycleRequest.DOC = "";


    this.actorservice.GetIvfCycleEmbryoTransferrablesController(this.CurrentIvfCycleEmbryoTransferrablesRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentIvfCycleEmbryoTransferrablesController = this.ApiResData.Result;
          this.length = this.CurrentIvfCycleEmbryoTransferrablesController.length;
          this.spinner.hide();
          //this.CurrentIvfCycleEmbryoTransferrablesController1 = this.CurrentIvfCycleEmbryoTransferrablesController.filter(function (a) {
          //    return a.StrawNumber == '1';
          //});
          //this.CurrentIvfCycleEmbryoTransferrablesController2 = this.CurrentIvfCycleEmbryoTransferrablesController.filter(function (b) {
          //    return b.StrawNumber == '2';
          //});
          //this.CurrentIvfCycleEmbryoTransferrablesController3 = this.CurrentIvfCycleEmbryoTransferrablesController.filter(function (c) {
          //    return c.StrawNumber == '3';
          //});
          // this.LoadGradingData3();
          //   var _CurrentIvfEmbryoGradingByCycleController: IvfEmbryoGradingByCycleController[]  = this.ApiResData.Result;
          //   alert('grades count: ' + _CurrentIvfEmbryoGradingByCycleController.length.toString());
          //this.CurrentIvfEmbryoGradingByCycleController = _CurrentIvfEmbryoGradingByCycleController.filter(
          //    function (v, i, d) {
          //    //if (v.DOC.toString() == this.DOC)
          //    //    alert('Mmmmmm');
          //        return this.checkDoc(v.DOC);//.toString() == this.DOC
          //});
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentIvfCycleEmbryoTransferrablesControllerByActor: IvfCycleEmbryoTransferrablesController[];
  //CurrentIvfCycleEmbryoTransferrablesControllerByActor1: IvfCycleEmbryoTransferrablesController[];
  //CurrentIvfCycleEmbryoTransferrablesControllerByActor2: IvfCycleEmbryoTransferrablesController[];
  //CurrentIvfCycleEmbryoTransferrablesControllerByActor3: IvfCycleEmbryoTransferrablesController[];
  CurrentIvfCycleEmbryoTransferrablesRequestByActor: IvfCycleEmbryoTransferrablesRequest;

  LoadGradingData3(StrawNumber: string) {
    //alert("ScansData")
    this.CurrentIvfCycleEmbryoTransferrablesRequestByActor = new IvfCycleEmbryoTransferrablesRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleEmbryoTransferrablesRequestByActor.StrawNumber = StrawNumber;
    this.CurrentIvfCycleEmbryoTransferrablesRequestByActor.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleEmbryoTransferrablesController2();
  }
  //AddRowMaturity() {
  //  if (this.CurrentOocyteMaturityByCycleController == null) {
  //    this.CurrentOocyteMaturityByCycleController = new Array<OocyteMaturityByCycleController>();
  //  }
  //  if (this.CurrentOocyteMaturityByCycleController != null) {

  //    var row = new OocyteMaturityByCycleController();

  //    row.MaturityLevel = "";
  //    row.OccCount = 0;
  //    row.DenudedCount = 0;
  //    this.CurrentOocyteMaturityByCycleController.push(row);
  //    this.tosterservice.ToasterSuccessAlertParam('New Row Added Successfully.....!');

  //  }

  //}
  //checkDoc(val: number): boolean {
  //    return val.toString() == this.DOC;
  //}
  GetIvfCycleEmbryoTransferrablesController2() {
    this.spinner.show();
    //  alert(this.DOC);
    this.CurrentIvfCycleEmbryoTransferrablesRequestByActor.ConditionalOperator = 20;
    if (this.EggSourceType == 'Donor') {
      this.CurrentIvfCycleEmbryoTransferrablesRequestByActor.ActorCode = this.EggActorCode;
    }
    else if (this.EggSourceType == 'Self') {
      this.CurrentIvfCycleEmbryoTransferrablesRequestByActor.ActorCode = this.EggActorCode;
    }

    // this.CurrentIvfEmbryoGradingByCycleRequest.DOC = "";


    this.actorservice.GetIvfCycleEmbryoTransferrablesController(this.CurrentIvfCycleEmbryoTransferrablesRequestByActor)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentIvfCycleEmbryoTransferrablesControllerByActor = this.ApiResData.Result;
          this.length2 = this.CurrentIvfCycleEmbryoTransferrablesControllerByActor.length;
          this.spinner.hide();
          //this.CurrentIvfCycleEmbryoTransferrablesControllerByActor1 = this.CurrentIvfCycleEmbryoTransferrablesControllerByActor.filter(function (a) {
          //    return a.StrawNumber == '1';
          //});
          //this.CurrentIvfCycleEmbryoTransferrablesControllerByActor2 = this.CurrentIvfCycleEmbryoTransferrablesControllerByActor.filter(function (b) {
          //    return b.StrawNumber == '2';
          //});
          //this.CurrentIvfCycleEmbryoTransferrablesControllerByActor3 = this.CurrentIvfCycleEmbryoTransferrablesControllerByActor.filter(function (c) {
          //    return c.StrawNumber == '3';
          //});
          //   var _CurrentIvfEmbryoGradingByCycleController: IvfEmbryoGradingByCycleController[]  = this.ApiResData.Result;
          //   alert('grades count: ' + _CurrentIvfEmbryoGradingByCycleController.length.toString());
          //this.CurrentIvfEmbryoGradingByCycleController = _CurrentIvfEmbryoGradingByCycleController.filter(
          //    function (v, i, d) {
          //    //if (v.DOC.toString() == this.DOC)
          //    //    alert('Mmmmmm');
          //        return this.checkDoc(v.DOC);//.toString() == this.DOC
          //});
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private spinner: NgxSpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
    private tosterservice: NGXToastrService, private modalService: NgbModal) { }
  ngOnInit() {
    this.CurrentSaveProviderServiceChargeRequest = new SaveProviderServiceChargeRequest();
    //this.CurrentSaveProviderServiceChargeRequest.ConditionalOperator = 20;
    this.CurrentSaveProviderServiceChargeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveEmbryoStoreInfoRequest = new SaveEmbryoStoreInfoRequest();
    this.CurrentSaveEmbryoStoreInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentDeleteProviderServiceChargeRequest = new SaveProviderServiceChargeRequest();
    this.CurrentDeleteProviderServiceChargeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveIvfCycleEmbryoTransferredInfoRequest = new SaveIvfCycleEmbryoTransferredInfoRequest();
    this.CurrentSaveIvfCycleEmbryoTransferredInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ShowService = false;
    this.ValueChangeActorImageController = new ActorImageController();
    //alert(this.StrawNumber);
    //this.LoadGradingData();
    //this.LoadRegistries();
    this.LoadPatients();
    //this.LoadGradingData2();
    //this.LoadGradingData3();

  }



  //GetBranchMap() {
  //  this.StartRefreshing();
  //  this.BranchMapRequest.ServiceCode = this.ServiceCode;

  //  this.actorservice.GetServiceBranchMapByServiceCodeController(this.BranchMapRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.BranchMapData = this.ApiResData.Result;
  //        //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
  //        //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
  //        //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );


  //}
  SelectPresentstep1(l: IvfCycleEmbryoTransferrablesController) {
    this.TabsView = false;
    this.EmbryoSelected = true;
    this.SelectedEmbryoDetails = true;
    this.DOC1 = l.DOC;
    this.Count = l.EmbryoCount;
    this.Grade1new = l.Grade1;
    this.Grade2new = l.Grade2;
    this.Cyclenumber1 = l.CycleNumber;
    this.Date3 = l.CreatedTimeStamp;
    this.Cyclenumberdonor = l.TreatmentCycle;
    this.StrawSelected = l.StrawNumber;
    this.Cycleno = l.CycleNo;
    this.LoadEmbryoData(this.StrawSelected);
    //this.GetSelectedStrawStorgae();
  }
  CurrentIvfCycleEmbryoStorageAreaController: IvfCycleEmbryoStorageAreaController[];
  SelectedStrawData: IvfCycleEmbryoStorageAreaController[];
  CurrentIvfCycleEmbryoStorageAreaRequest: IvfCycleEmbryoStorageAreaRequest;
  LoadEmbryoData(StrawSelected: string) {
    this.CurrentIvfCycleEmbryoStorageAreaRequest = new IvfCycleEmbryoStorageAreaRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    //this.CurrentIvfCycleEmbryoStorageAreaRequest.Branch = 0;
    this.CurrentIvfCycleEmbryoStorageAreaRequest.EmbryoGradingCode = 0;
    this.CurrentIvfCycleEmbryoStorageAreaRequest.ConditionalOperator = 20;

    this.CurrentIvfCycleEmbryoStorageAreaRequest.CycleCode = this.Cyclenumber;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentIvfCycleEmbryoStorageAreaRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleEmbryoStorageAreaController(StrawSelected);
  }

  GetIvfCycleEmbryoStorageAreaController(StrawNumber: string) {
    //this.StartRefreshing();


    this.actorservice.GetIvfCycleEmbryoStorageAreaController(this.CurrentIvfCycleEmbryoStorageAreaRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //this.CurrentIvfCycleEmbryoStorageAreaController = this.ApiResData.Result;
          this.SelectedStrawData = this.ApiResData.Result;
          this.CurrentIvfCycleEmbryoStorageAreaController = this.SelectedStrawData.filter(
            function (a) {
              return a.StrawNumber == StrawNumber;

            });
          //this.GetSelectedStrawStorage(this.StrawSelected);

          /// this.GetSelectedStrawStorgae(this.StrawSelected);
          //this.ActorCodeDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
          //this.SelectedActorCode = this.CurrentTreatmentCyclesByActorCodeController[0].EggActorCode;
          //this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
          //this.LMPDate = this.SelectedTreatmentCycle.LMP;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();
          //this.LoadPlan();
          //this.LoadDSAData();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  //    GetSelectedStrawStorage(StrawNumber: string) {
  //        this.CurrentIvfCycleEmbryoStorageAreaController = this.SelectedStrawData.filter(function (a) {
  //            return a.StrawNumber == StrawNumber;
  //        });

  //}
  SelectPresentstep2(l: IvfCycleEmbryoStorageAreaController) {
    this.EmbryoSelected = false;
    this.SelectedEmbryoDetails = false;
    this.SelectedEmbryoStoreDetails = true;
    this.SaveTransfer = true;
    this.Canisterno = l.CanisterNo;
    this.Goblet = l.Goblet;
    this.Hexa = l.Hexa;
    this.Viso = l.Viso;
    this.UsedCount = l.EmbryoCount;
    this.EmbryoGradingCode = l.EmbryoGrading;
    this.EmbryostoreCode = l.IvfCycleEmbryoStorageAreaCode;
    this.EmbryoTransferCode = l.IvfCycleEmbryoTransferCode;
  }

  SelectPresent() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {

      ///this.IsGradingCompleted();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })
  }



  openDocContent() {

    let options: NgbModalOptions = {
      size: 'lg'
    };
    const modalRef = this.modalService.open(NgbActorDocsModal, options)//.result(result => { this.GetActorProfileController();});
    modalRef.componentInstance.ActorDocCode = this.ImageCodenew;
    modalRef.componentInstance.ActorCode = this.ActorCode;
    modalRef.componentInstance.DocType = "Embryo Grading";
    modalRef.componentInstance.DocTitle = "Embryo Grading";
    //modalRef.componentInstance.CanEdit = 1;
    //modalRef.componentInstance.CanShow = 1;
    modalRef.result.then(x => {
      //  alert('Received: ' + x);
      var data: ApiResponseModel = x;
      this.ImageCodenew = data.Result;
      //    this.GetActorIdentitiesController()
    })


  }



  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  dataChanged(StrawNumber: string) {
    //alert(StrawNumber);
    this.LoadGradingData3(StrawNumber);
  }
  dataChanged2(StrawNumber2: string) {
    this.LoadGradingData2(StrawNumber2);
  }

  discarddata() {
    this.freeze = false;
    this.Transfer = false;
    this.discard = true;
  }
  Freezedata() {
    this.discard = false;
    this.Transfer = false;
    this.freeze = true;
  }
  Transferdata() {
    this.freeze = false;
    this.discard = false;
    this.Transfer = true;
  }
  EditStore2(l: IvfEmbryoGradingByCycleController) {
    this.Select = true;
    this.model = "";
    //this.CurrentSaveEmbryoStoreInfoRequest.Count = l.EmbryoCount;
    this.CurrentSaveEmbryoStoreInfoRequest.CellStage = l.CellStage;
    this.CurrentSaveEmbryoStoreInfoRequest.DOC = l.DOC;
    this.CurrentSaveEmbryoStoreInfoRequest.FetDropletGradingCode = 0;
    this.CurrentSaveEmbryoStoreInfoRequest.Grade = l.Grade1 + l.Grade2;

    this.Grade1 = l.Grade1;
    this.Grade2 = l.Grade2;
    this.Date = l.LastModifiedTime;
    this.DOC = l.DOC;
    this.Embryocount = l.EmbryoCount;

  }
  BackToStep1() {
    this.TabsView = true;
    this.EmbryoSelected = false;
    this.SelectedEmbryoDetails = false;
  }
  onSubmit() {
    this.spinner.show();
    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
    this.CurrentSaveEmbryoStoreInfoRequest.ConditionalOperator = 10;

    this.CurrentSaveEmbryoStoreInfoRequest.ActorCode = this.ActorCode;// this.ValueChangeActorImageController.ActorImageCode;
    this.CurrentSaveEmbryoStoreInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    this.CurrentSaveEmbryoStoreInfoRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSaveEmbryoStoreInfoRequest.CycleCode = this.Cyclenumber;
    this.CurrentSaveEmbryoStoreInfoRequest.Date = new Date();

    this.actorservice.SaveEmbryoStoreInfo(this.CurrentSaveEmbryoStoreInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            this.spinner.hide();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }
  TransferCompleted() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {

      this.onSubmit2();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })

  }
  onSubmit2() {
    this.spinner.show();
    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
    this.CurrentSaveIvfCycleEmbryoTransferredInfoRequest.ConditionalOperator = 10;
    this.CurrentSaveIvfCycleEmbryoTransferredInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSaveIvfCycleEmbryoTransferredInfoRequest.TimeStamp = new Date();
    this.CurrentSaveIvfCycleEmbryoTransferredInfoRequest.EmbryoGrading = this.EmbryoGradingCode;
    this.CurrentSaveIvfCycleEmbryoTransferredInfoRequest.CycleStore = this.EmbryostoreCode;
    this.CurrentSaveIvfCycleEmbryoTransferredInfoRequest.EmbryoTransferredCode = this.EmbryoTransferCode;
    this.CurrentSaveIvfCycleEmbryoTransferredInfoRequest.Purpose = "";
    if (this.EggSourceType == 'Donor') {
      this.CurrentSaveIvfCycleEmbryoTransferredInfoRequest.FromTreatmentCycle = this.Cyclenumberdonor;
    }
    else {
      this.CurrentSaveIvfCycleEmbryoTransferredInfoRequest.FromTreatmentCycle = this.Cyclenumber;
    }

    this.CurrentSaveIvfCycleEmbryoTransferredInfoRequest.Regrade3 = "";
    this.CurrentSaveIvfCycleEmbryoTransferredInfoRequest.StorageArea = this.EmbryostoreCode;
    this.CurrentSaveIvfCycleEmbryoTransferredInfoRequest.ToTreatmentCycle = this.Cyclenumber;
    this.CurrentSaveIvfCycleEmbryoTransferredInfoRequest.TransferAttempt = 0;
    //this.CurrentSaveIvfCycleEmbryoTransferredInfoRequest.
    // this.CurrentSaveEmbryoStoreInfoRequest.ActorCode = this.ActorCode;// this.ValueChangeActorImageController.ActorImageCode;
    // this.CurrentSaveEmbryoStoreInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    //this.CurrentSaveEmbryoStoreInfoRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;
    //this.CurrentSaveEmbryoStoreInfoRequest.CycleCode = this.Cyclenumber;
    // this.CurrentSaveEmbryoStoreInfoRequest.Date = new Date();

    this.actorservice.SaveIvfCycleEmbryoTransferredInfo(this.CurrentSaveIvfCycleEmbryoTransferredInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            this.spinner.hide();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }
}
